import { addError } from './monitoring'
import { isEnabled } from './toggles'

/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
const logMessage = (level: string, message: string, ...args: any): void => {
  switch (level) {
    case 'DEBUG':
      console.debug(`[${level}] ${message}`, ...args)
      break
    case 'INFO':
      console.info(`[${level}] ${message}`, ...args)
      break
    case 'WARN':
      console.warn(`[${level}] ${message}`, ...args)
      break
    case 'ERROR':
      console.error(`[${level}] ${message}`, ...args)
      if (isEnabled('datadogRum')) {
        addError(new Error(message), args)
      }
      break
    case 'SUCCESS':
      console.log(`[${level}] ${message}`, ...args)
      break
    default:
      throw Error(`Invalid log level "${level}"`)
  }
}

export const debug = (message: string, ...args: any): void => logMessage('DEBUG', message, ...args)

export const info = (message: string, ...args: any): void => logMessage('INFO', message, ...args)

export const warn = (message: string, ...args: any): void => logMessage('WARN', message, ...args)

export const error = (message: string, ...args: any): void => logMessage('ERROR', message, ...args)

export const success = (message: string, ...args: any): void => logMessage('SUCCESS', message, ...args)
